import React, { useEffect, useState } from "react";

import "./innerLayout.css";
import LeftSidebar from "./components/leftSidebar";
import Header from "./components/header";
import HandWave from "../../assets/dashboard/handWave.svg";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { profileSettingService } from "../../services/profileSettingService/profileSettingService";
import { setDiscussionCategories } from "../../redux/authSlice";
import {logout, setUserData} from "../../redux/authSlice";
import {useLocation, useNavigate} from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import {discussionCategoriesService} from "../../services/authService/discussionCategoriesService";
import WelcomeVideoModal from "../../pages/auth/components/welcome-video-modal/WelcomeVideoModal";

const InnerLayout = ({ children }) => {
    const userData = useSelector((state) => state?.auth?.userData);
    const loginUserData = useSelector((state) => state?.auth?.auth);
    const [isLoading, setIsLoading] = useState(false);
    const [isCategoriesLoading, setIsCategoriesLoading] = useState(false);
    const dispatch = useDispatch();
    const location = useLocation();
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!userData?.id) {
            getUserAllData();
        }
        getDiscussionCategories();
    }, []);

    const getUserAllData = async () => {
        try {
            setIsLoading(true);
            const response = await profileSettingService.getUserProfileData(loginUserData?.id);
            const fetchedUserData = response?.data?.data;
            dispatch(setUserData(fetchedUserData));
            setIsLoading(false);
        } catch (error) {
            console.error("API error:", error);

            if (error.response.status === 401) {
                dispatch(logout());
                sessionStorage.clear();
                localStorage.clear();
                navigate("/");
            }

            setIsLoading(false);
        }
    };

    const getDiscussionCategories = async () => {
        try {
            setIsCategoriesLoading(true);
            const categoriesResponse = await discussionCategoriesService.getDiscussionCategories();
            const fetchedDiscussionCategories = categoriesResponse?.data?.data;
            dispatch(setDiscussionCategories(fetchedDiscussionCategories));
            setIsCategoriesLoading(false);
        } catch (error) {
            console.error("API error:", error);
            setIsCategoriesLoading(false);
        }
    };

    const isProfileSettingRoute = location.pathname === "/profile-settings";

    return (
        <div className="main-wrapper">
            <Header />
            <LeftSidebar isLoading={isLoading || isCategoriesLoading} />
            <div className="page-wrapper">
                <div className="container-fluid">
                    <div className="common-layout-section p-3">
                        {isProfileSettingRoute ? null : (
                            <div className="d-flex d-lg-none justify-content-start align-items-center text-nowrap gap-3 p-2">
                                <img crossOrigin="anonymous" src={HandWave} alt="Hello" width={20} />
                                <div>
                                    {t("COMMON.WELCOME.BACK")}, {userData?.first_name}&nbsp;
                                    {userData?.last_name}
                                </div>
                            </div>
                        )}
                        <Outlet />
                    </div>
                </div>
            </div>
            {!userData?.welcomed_at && <WelcomeVideoModal />}
        </div>
    );
};

export default InnerLayout;
